var Apidae_Map = (function() {
    var self = {};
    var map;
    var prestas;
    var markers = [];
    var markersFake = [];
    var polysFake = [];
    var mapIconOff = fmz.asset_url + 'img/mapIcon/mapIconOff.png';
    var mapIconOn = fmz.asset_url + 'img/mapIcon/mapIconOn.png';
    var zoomChanged;
    var dragend;

    self.setMarkers = function(ini) {
        /// google.maps.event.removeListener(zoomChanged);
        /// google.maps.event.removeListener(dragend);

        // delete existing marker and infobox
        /// for (var i = 0; i < markers.length; i++) {
        ///     markers[i].setMap(null);
        ///     markers[i].infobox.close();
        /// }
        /// markers = [];

        /// var infowindow =  new google.maps.InfoWindow({
        ///     content: ''
        /// });
        
        // Apidae_Util.ajaxSend();

        map.getLayers().getArray()
            .filter(layer => layer.get('name') === 'vectorLayer')
            .forEach(function(layer, i) {
                // console.log(layer.get('name'))

                var features = layer.getSource().getFeatures();
                features.forEach((feature) => {
                    layer.getSource().removeFeature(feature);
                });
                layer.getSource().clear();
                // console.log(layer)
                // var features = layer.getSource().getFeatures();
                // console.log(features)
                // features.forEach((feature) => {
                //     layer.getSource().removeFeature(feature);
                // });
                map.removeLayer(layer);
                markers = [];
            });

        jQuery.ajax({
            url: window.location.protocol + '//' + window.location.host + window.location.pathname + '/map' + '?' + $(document.body).find('#searchForm').serialize(),
            dataType: 'json',
            success: function(data) {
                if (data.status == 'OK') {
                    prestas = data.prestas;
                    // loop through prestas and add markers
                    // console.log(prestas);

                    for (p in prestas) {

                        var lat = parseFloat(prestas[p].latitude);
                        var long = parseFloat(prestas[p].longitude);
                        // var latlong = ol.proj.fromLonLat([long, lat]);

                        var marker = new ol.Feature({
                            // geometry: new ol.geom.Point(latlong)
                            infoHtml: prestas[p].infoHtml,
                            geometry: new ol.geom.Point(ol.proj.transform([long, lat], 'EPSG:4326', 'EPSG:3857')),
                        });

                        // Custom image for marker
                        var iconStyle = new ol.style.Style({
                            image: new ol.style.Icon( /** @type {olx.style.IconOptions} */ ({
                                anchor: [0.5, 46],
                                anchorXUnits: 'fraction',
                                anchorYUnits: 'pixels',
                                src: mapIconOff
                            }))
                        });

                        marker.setStyle(iconStyle);
                        markers.push(marker);

                        //create gmap latlng obj
                        /// tmpLatLng = new google.maps.LatLng( prestas[p].latitude, prestas[p].longitude);
                        // make and place map maker.
                        /// var marker = new google.maps.Marker({
                        ///     map: map,
                        ///     position: tmpLatLng,
                        ///     title : prestas[p].title,
                        ///     icon: mapIconOff
                        /// });

                        var southLat = $('#South_Lat').val();
                        var southLng = $('#South_Lng').val();
                        var northLat = $('#North_Lat').val();
                        var northLng = $('#North_Lng').val();

                        // Extension des limites (bounds) de la map grâce à la méthode extend
                        if (southLat > 0 && southLng > 0 && northLat > 0 && northLng > 0) {

                            /// var sw = new google.maps.LatLng(southLat,southLng);
                            /// var ne = new google.maps.LatLng(northLat,northLng);

                            /// bounds.extend(sw);
                            /// bounds.extend(ne);
                        } else {
                            /// bounds.extend(tmpLatLng);
                        }

                        /*bindInfoWindow(marker, map, infowindow, prestas[p].infoHtml);*/

                    }
                    // console.log(markers);
                    var vectorSource = new ol.source.Vector({
                        features: markers
                    });

                    var vectorLayer = new ol.layer.Vector({
                        source: vectorSource,
                        // style: iconStyle,
                        // updateWhileAnimating: true,
                        // updateWhileInteracting: true,
                    });

                    map.addLayer(vectorLayer);
                    // map.getLayers().extend([vectorLayer]);
                    vectorLayer.set('name', 'vectorLayer');
                    // map.getLayers().insertAt(2, vectorLayer);

                    // zoom de la map en fonction des limites
                    if (ini) {
                        ///     map.fitBounds(bounds);
                        var extent = vectorLayer.getSource().getExtent();
                        map.getView().fit(extent, map.getSize());
                    }
                    // console.log(map.getLayers().getArray());
                    // $(document).on('change', '#searchForm', function(e) {

                    //     var features = vectorLayer.getSource().getFeatures();
                    //     features.forEach((feature) => {
                    //         vectorLayer.getSource().removeFeature(feature);
                    //     });
                    // });



                    /* Ajustement du niveau de zoom */
                    /// var zoomLevel = $('#Zoom_Level').val();
                    /// if(zoomLevel > 0){
                    ///     map.setZoom(parseInt(zoomLevel));
                    /// }
                    /*Apidae_Util.ajaxComplete();*/
                }
            },
            complete: function() {

                /// zoomChanged = google.maps.event.addListener(map, 'zoom_changed', function () {

                ///     if($("#searchByMap").is(':checked')){
                ///         /* niveau de zoom de la map */
                ///         var zl = map.getZoom();
                ///         $('#Zoom_Level').val(zl);

                ///         /* coordonnées des coins de la map */
                ///         var bds = map.getBounds();
                ///         var South_Lat = bds.getSouthWest().lat();
                ///         var South_Lng = bds.getSouthWest().lng();
                ///         var North_Lat = bds.getNorthEast().lat();
                ///         var North_Lng = bds.getNorthEast().lng();
                ///         $('#South_Lat').val(South_Lat);
                ///         $('#South_Lng').val(South_Lng);
                ///         $('#North_Lat').val(North_Lat);
                ///         $('#North_Lng').val(North_Lng).trigger("change");

                ///         Apidae_Search.search();
                ///     }
                /// });

                /// dragend = google.maps.event.addListener( map, 'dragend', function(){
                ///     if($("#searchByMap").is(':checked')) {
                ///         google.maps.event.trigger(this, 'zoom_changed');
                ///     }
                /// });
                Apidae_Util.ajaxComplete();
            }
        });
    };

    // binds a map marker and infoWindow together on click
    /*var bindInfoWindow = function(marker, map, infowindow, html) {
        google.maps.event.addListener(marker, 'click', function() {
    
            for (var i = 0; i < markers.length; i++) {
                markers[i].setIcon(mapIconOff);
            }
            this.setIcon(mapIconOn);
    
            //map.panTo(e.latLng);
            infowindow.setContent(html);
            infowindow.open(map, marker);
        });
    };*/

    // binds a map marker and infoBox together on click
    var bindInfoWindowInfoBox = function(map) {
        //POPUP
        var popup = new ol.Overlay.Popup();
        map.addOverlay(popup);

        // Add an event handler for when someone clicks on a marker
        map.on('singleclick', function(evt) { 

            // Hide existing popup and reset it's offset
            popup.hide();
            popup.setOffset([0, 0]);

            // Attempt to find a feature in one of the visible vector layers
            var feature = map.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
                return feature;
            });

            if (feature) {
                var coord = feature.getGeometry().getCoordinates();
                var props = feature.getProperties();
                var info = props.infoHtml;

                // Offset the popup so it points at the middle of the marker not the tip
                popup.setOffset([-120, -52]);
                popup.show(coord, info);
            }
        });

        // Add an event handler for when someone hovers over a marker
        // This changes the cursor to a pointer
        map.on("pointermove", function(evt) {
            var hit = map.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
                return true;
            });
            if (hit) {
                this.getTargetElement().style.cursor = 'pointer';
            } else {
                this.getTargetElement().style.cursor = '';
            }
        });

        /// var boxText = document.createElement("div");
        /// boxText.style.cssText = "margin-bottom: 10px; background-color: #20232b; padding-bottom: 10px;";
        /// boxText.innerHTML = html;
        /// var currentMarker;

        /// var myOptions = {
        ///     content: boxText,
        ///     alignBottom: true,
        ///     disableAutoPan: false,
        ///     maxWidth: 0,
        ///     pixelOffset: new google.maps.Size(-140, -60),
        ///     zIndex: null,
        ///     boxStyle: {
        ///         background: "url('" + /base_url + theme_url + "/img/mapIcon/tipBox.png') bottom center no-repeat",
        ///         opacity: 1,
        ///         width: "280px",
        ///         height: "223px"
        ///     },
        ///     closeBoxMargin: "2px 2px 2px 2px",
        ///     closeBoxURL: base_url + '/' + theme_url + '/img/close.png',
        ///     infoBoxClearance: new google.maps.Size(1, 1),
        ///     isHidden: false,
        ///     pane: "floatPane",
        ///     enableEventPropagation: false
        /// };

        /// google.maps.event.addListener(marker, "click", function(e) {

        ///     for (var h = 0; h < markers.length; h++) {
        ///         markers[h].setIcon(mapIconOff);
        ///         markers[h].infobox.close();
        ///     }
        ///     this.setIcon(mapIconOn);

        ///     this.infobox.open(map, this);

        ///     currentMarker = this;
        /// });

        /// marker.infobox = new InfoBox(myOptions);
        /// /*ib.open(map, marker);*/

        /// google.maps.event.addListener(marker.infobox, 'closeclick', function() {
        ///     currentMarker.setIcon(mapIconOff);
        /// });
    };

    self.init = function() {
        var latitude = 43.3369947;
        var longitude = 6.5111747;

        // Create our initial map view
        var mapCenter = ol.proj.fromLonLat([longitude, latitude]);
        var view = new ol.View({
            center: mapCenter,
            zoom: 12,
            maxZoom: 17
        });

        var resolutions = [
            156543.03392804103,
            78271.5169640205,
            39135.75848201024,
            19567.879241005125,
            9783.939620502562,
            4891.969810251281,
            2445.9849051256406,
            1222.9924525628203,
            611.4962262814101,
            305.74811314070485,
            152.87405657035254,
            76.43702828517625,
            38.218514142588134,
            19.109257071294063,
            9.554628535647034,
            4.777314267823517,
            2.3886571339117584,
            1.1943285669558792,
            0.5971642834779396,
            0.29858214173896974,
            0.14929107086948493,
            0.07464553543474241
        ];

        // Now create our map
        if (fmz.ign_key.length > 0) {
            map = new ol.Map({
                interactions: ol.interaction.defaults({
                    mouseWheelZoom: false
                }),
                target: 'mapPrestas',
                view: view,
                // layers: [
                //     new ol.layer.Tile({
                //         source: new ol.source.OSM(),
                //     })
                //     // , vectorLayer
                // ],
                // layers: [
                //     new ol.layer.Tile({
                // 	source: new ol.source.BingMaps({
                // 		key: 'ArzN4ZZuog7ZY5y9OXsU6Nu7ugzL9maxglzoFIpVlhpv08A11P02nw0GXbrCcVd9',
                // 		imagerySet: 'Aerial'
                // 		// use maxZoom 19 to see stretched tiles instead of the BingMaps
                // 		// "no photos at this zoom level" tiles
                // 		// maxZoom: 19
                // 	})
                // })
                // ],
                /// loadTilesWhileAnimating: true,
                // controls: ol.control.defaults({
                //     attributionOptions: {
                //         collapsible: false
                //     }
                // })
                layers: [
                    new ol.layer.Tile({
                        source: new ol.source.WMTS({
                            url: "https://data.geopf.fr/wmts?REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&TILEMATRIXSET=PM",
                            layer: "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2",
                            style: 'normal',
                            format: 'image/png',
                            service: 'WMTS',
                            tileGrid: new ol.tilegrid.WMTS({
                                origin: [-20037508, 20037508], // topLeftCorner
                                resolutions: resolutions, // résolutions
                                matrixIds: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19"] // ids des TileMatrix
                            })
                        })
                    })
                    // , vectorLayer
                ],
            });

        } else {
            map = new ol.Map({
                interactions: ol.interaction.defaults({
                    mouseWheelZoom: false
                }),
                target: 'mapPrestas',
                view: view,
                layers: [
                    new ol.layer.Tile({
                        source: new ol.source.OSM(),
                    })
                    // , vectorLayer
                ],
            });
        }

        // fetch the prestas (ajax) and put them on the map
        self.setMarkers(true);
        bindInfoWindowInfoBox(map);
        loadData = false;

        //add marker on grid item hover
        $(document.body).on('mouseenter mouseleave', '.grid__item', function(e) {
            var $this = $(this);

            //trace
            ///     var urlPlan = $this.data('plan');
            ///     if(!!urlPlan)
            ///         e.type == 'mouseenter' ? addPolyline(urlPlan) : delPolyline(idxTrace);

            //marker
            var lat = $this.data('latitude');
            var long = $this.data('longitude');
            if (!!lat && !!long)
                e.type == 'mouseenter' ? addMarker(lat, long) : delMarker();
        });

        var addMarker = function(lat, long) {
            var marker = new ol.Feature({
                geometry: new ol.geom.Point(ol.proj.transform([long, lat], 'EPSG:4326', 'EPSG:3857')),
            });

            // Custom image for marker
            var iconStyle = new ol.style.Style({
                image: new ol.style.Icon( /** @type {olx.style.IconOptions} */ ({
                    anchor: [0.5, 46],
                    anchorXUnits: 'fraction',
                    anchorYUnits: 'pixels',
                    src: mapIconOn
                }))
            });

            marker.setStyle(iconStyle);

            var vectorSource = new ol.source.Vector({
                features: [marker]
            });

            var markerFake = new ol.layer.Vector({
                source: vectorSource,
            });

            map.addLayer(markerFake);
            markerFake.set('name', 'markerFake');
        };

        var delMarker = function() {
            map.getLayers().forEach(function(layer) {
                if (layer.get('name') != undefined ) {
                    if(layer.get('name') === 'markerFake') {
                        map.removeLayer(layer);
                    }
                }
            });
        };

        var addPolyline = function(urlPlan) {
            $.ajax({
                /// type: "GET",
                /// url: base_url + '/XmlToJson.php',
                /// data: 'url=' + urlPlan,
                /// dataType: "json",
                /// success: function(data) {
                ///     var points = [];
                ///     var bounds = new google.maps.LatLngBounds();
                        // $.each(data.trk.trkseg, function() {
                        //     $.each(this.trkpt, function() {
                        //         //console.log(this['@attributes'].lat);
                        //         var lat = this['@attributes'].lat;
                        //         var lon = this['@attributes'].lon;
                        //         var p = new google.maps.LatLng(lat, lon);
                        //         points.push(p);
                        //         bounds.extend(p);
                        //     });
                        // });

                ///     var polyFake = new google.maps.Polyline({
                ///         path: points,
                ///         map: map,
                ///         strokeColor: "#FF00AA",
                ///         strokeOpacity: 1,
                ///         strokeWeight: 4
                ///     });

                ///     idxTrace = polyFake.__gm_id;
                ///     polysFake[idxTrace] = polyFake;
                /// }
            });
        };

        var delPolyline = function(idxTrace) {
            /// polyFake = polysFake[idxTrace];
            /// polyFake.setMap(null);
        };
    };

    self.resize = function() {
        setTimeout(function() {
            map.updateSize();
        }, 200);
        /// var center = map.getCenter();
        /// google.maps.event.trigger(map, 'resize');
        /// map.setCenter(center);
        /// map.setZoom(8);
    };

    return self;
})();

$(window).on("load", function() {
    if ($('#mapPrestas').length) {
        Apidae_Map.init();
    }
});